import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { InteractionStatus } from "@azure/msal-browser";
import Spinner from "../components/Spinner";
import useLoggedInAccount from "./LoggedInAccountInfo";
import { setUser } from '../store/slices/userSlice';
import { useDispatch } from "react-redux";
import { createUsersApi } from "../api-helpers/UserApiHelper";

const AuthContext = ({ children }: any) => {
  const { instance, inProgress, loggedInAccount } = useLoggedInAccount();

  const location = useLocation();
  const dispatch = useDispatch();
  const isGatewayEnabled = process.env.REACT_APP_CONFIG_GATEWAY === "true";
  const clientTenantId = process.env.REACT_APP_CLIENT_TENANT_ID;

  const userApi = createUsersApi();

  useEffect(() => {
    const activeAccount = instance.getActiveAccount();
    if((!activeAccount || (activeAccount && activeAccount.tenantId !== clientTenantId)) && loggedInAccount){
      instance.setActiveAccount(loggedInAccount);
    }
  }, [loggedInAccount, instance]);

  useEffect(() => {
    const fetchUserData = async () => {
      const result = (await (userApi.usersControllerGetMe())).data;
      dispatch(setUser(result));
    }

    fetchUserData();
  }, [loggedInAccount]);

  useEffect(() => {
    const channel = new BroadcastChannel("auth");
    channel.onmessage = (event) => {
      if (event.data === "logout") {
        instance.logoutRedirect({
          postLogoutRedirectUri: '/',
        });
      }
    };
    return () => {
      channel.close();
    };
  }, [instance]);

  if (isGatewayEnabled) {
    if (!loggedInAccount && inProgress !== InteractionStatus.Login && inProgress !== InteractionStatus.Startup && inProgress !== InteractionStatus.HandleRedirect) {
      return <Navigate to="/" state={{ from: location }} replace />;
    }else if(!loggedInAccount && (inProgress === InteractionStatus.Logout || InteractionStatus.Login || inProgress=== InteractionStatus.Startup)){
      return <Spinner />;
    }

    return children;
  } else {
    localStorage.setItem("accessToken", "cbf0e3f5-4b95-444c-bcc2-f2820ffe1b8e");
    const sessionToken = localStorage.getItem("accessToken");

    if (!sessionToken) {
      return <Navigate to="/" state={{ from: location }} replace />;
    }

    return children;
  }
};

export default AuthContext;
